import { render } from "./Information.vue?vue&type=template&id=2e74d740"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Information.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e74d740"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e74d740', __exports__)) {
    api.reload('2e74d740', __exports__)
  }
  
  module.hot.accept("./Information.vue?vue&type=template&id=2e74d740", () => {
    api.rerender('2e74d740', render)
  })

}


export default __exports__